export const lightTheme = {
  colors: {
    background: '#eaeaea',
    backgroundBtnForm: '#eaeaea',
    secondBackground: '#ffffff',
    thirdBackground: '#ffffff',
    forthBackground: '#F6F6F6',
    primaryText: '#111111',
    secondText: '#343434',
    thirdText: '#343434',

    backgroundButton: '#E5EDFA',
    secondBackgroundButton: '#e3f3ff',
    colorButtonContentHover: '#3e85f3',
    userLabelColor: '#111111',
    userInputBorder: '1px solid rgba(17, 17, 17, 0.1)',
    calendarOutBorder: '1px solid #dce3e5',
    calendarInnerBackground: '#dce3e5',
    calendarText: '#343434  ',
    periodTypeBtnActive: '#cae8ff',
    periodTypeBtnNotActive: '#e3f3ff',
    periodTypeBtnActiveContent: '#3e85f3',
    taskListItemBackground: '#ffffff',
    modalWindow: '#ffffff',
    window404: '#ffffff',
    modalFormContent: 'rgba(52, 52, 52, 0.8)',
    modalFormLabel: 'rgba(52, 52, 52, 0.8)',
    taskItemBg: '#f7f6f9',
    textareaBg: '#f7f7f7',
    textareaBorder: 'transparent',
    reviewsList: 'rgba(227, 243, 255, 0.5)',
    reviewsContent: 'rgba(17, 17, 17, 0.7)',

    emptyStar: '#cec9c1',
    scrollbarBg: 'grey',
    buttonNotActive: '#e5edfa',
    userPlaceholder: 'rgba(17, 17, 17, 0.15)',
    buttonCalendar: '#606470',
    scrollColor: '#E6E4E4',
    bgScrollColor: '#f2f2f2',
    sideBarLabel: 'rgba(52, 52, 52, 0.5)',
    sideBarContent: 'rgba(52, 52, 52, 0.5)',
    sideBarActive: '#e3f3ff',
    disabledBatton: '#3e85f3',

    bgrAvatar: '#F8F8F8',
    bgrSection: '#f7f6f9',
    bgrCalendar: '#FFF',
    borderStat: '#e3f3ff',
    borderPeriodPaginator: '1px solid rgba(220, 227, 229, 0.50)',
    addTaskBgBtn: '#e3f3ff',
  },
};

export const darkTheme = {
  colors: {
    background: '#171820',
    backgroundBtnForm: '#3e85f3',
    secondBackground: '#21222c',
    thirdBackground: '#13151A',
    forthBackground: '#171820',
    primaryText: '#FFFFFF',
    secondText: '#FFFFFF',
    thirdText: '#ffffff',
    backgroundButton: '#21222C',
    secondBackgroundButton: '#353647',
    colorButtonContentHover: '#ffffff',
    userFormBorderInput: 'rgba(17, 17, 17, 0.10)',
    userLabelColor: 'rgba(250, 250, 250, 0.3)',
    userInputBorder: '1px solid rgba(255, 255, 255, 0.15)',
    calendarOutBorder: '1px solid rgba(255, 255, 255, 0.15)',
    calendarInnerBackground: 'rgba(255, 255, 255, 0.15)',
    calendarText: '#FFF',
    periodTypeBtnActive: '#3e85f3',
    periodTypeBtnNotActive: '#21222c',
    periodTypeBtnActiveContent: '#ffffff',
    taskListItemBackground: '#111111',
    modalWindow: '#171820',
    window404: '#171820',
    modalFormContent: '#ffffff',
    modalFormLabel: 'rgba(250, 250, 250, 0.3)',
    taskItemBg: '#171820',
    textareaBg: 'transparent',
    textareaBorder: 'rgba(255, 255, 255, 0.15)',
    reviewsList: '#21222c',
    reviewsContent: 'rgba(255, 255, 255, 0.7)',
    emptyStar: '#353647',
    scrollbarBg: '#2d3037',
    buttonNotActive: '#21222c',
    userPlaceholder: '#FFFFFF',
    buttonCalendar: '#d0d0d0',
    scrollColor: '#2D3037',
    bgScrollColor: '#21222C',
    sideBarLabel: 'rgba(250, 250, 250, 0.3)',
    sideBarContent: '#ffffff',
    sideBarActive: '#3e85f3',
    disabledBatton: '#3e85f3',

    bgrAvatar: '#171820',
    bgrSection: '#171820',
    bgrCalendar: '#21222C',
    borderStat: 'rgba(227, 243, 255, 0.15)',
    borderPeriodPaginator: '1px solid rgba(255, 255, 255, 0.15)',
    addTaskBgBtn: '#3E85F3',
  },
};

export const globalTheme = {
  breakpoints: { mobile: '375px', tablet: '768px', desktop: '1440px' },

  colors: {
    primary: '#3e85f3',
    secondary: '#2b78ef',
    lightBlue: '#e3f3ff',
    darkBlue: '#cae8ff',
    bgBlue: '#dcebf7',
    background: '#ffffff',
    backAvatar: '#f8f8f8',
    white: '#ffffff',
    blackTitle: '#171820',
    black: '#111111',
    text: '#343434',
    mainYellow: '#f3b249',
    lightYellow: '#fcf0d4',
    redError: '#da1414',
    redErrorLight: '#e74a3b',
    mainRed: '#ea3d65',
    lightRed: '#ffd2dd',
    greenValid: '#3cbc81',
    muted: '#f7f6f9',
    closeButton: '#111111',
    backdrop: 'rgba(0, 0, 0, 0.8)',
    bgDelBtn: 'rgba(234, 61, 101, 0.2)',
    bgDelHover: 'rgba(234, 61, 101, 0.5)',
    borderColor: '1px solid rgba(17, 17, 17, 0.15)',
    placeholderColor: 'rgba(17, 17, 17, 0.15)',
    lowTasksBg: '#CEEEFD',
    reviewsSliderBorder: 'rgba(17, 17, 17, 0.1)',
    reviewsSliderText: 'rgba(17, 17, 17, 0.7)',
    mainBlue: '#72c2f8',
  },

  shadow: {
    boxShadow: '4px 2px 16px rgba(136, 165, 191, 0.48)',
    modalShadow: '0px 4px 57px rgba(17, 17, 17, 0.05)',
    modalHoverShadow: '4px 2px 16px 0px rgba(136, 165, 191, 0.48)',
    toolMenuShadow: '0px 4px 16px 0px rgba(17, 17, 17, 0.1)',
  },

  cubic: {
    cubicBezier: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },

  fonts: {
    fontsBody: 'Coolvetica',
    fontsHeading: 'Inter',
    fontsText: 'Inter',
  },
};
